
if($( window ).width() < 746){
    $('#video .videoBg').addClass('nonMobileBg')
                       .css('height','')
                       .attr('data-vide-bg','')
                       .attr('data-vide-options','')
                       .html('');
}else{
    loadScript('https://www.grandbohemia.cz/scripts/libs/jquery.vide.js');
}

$(document).ready(function() {

    var $lg = $('.reference').lightGallery({
        selector: 'a'
    });

    $lg.on('onBeforeOpen.lg',function(event){
        $(this).find('.img').find('img:not(.lazy)').each(function() {
            $(this).attr('src',$(this).attr('data-src'));
        });
    });

    constMenuWidth = 794;

    $('.photo').magnificPopup({
        type: 'image',
        gallery: {
            enabled: true
        }
    });

    $('.btn-iframe').magnificPopup({
        type: 'iframe',
        gallery: {
            enabled: false
        }
    });

    $('.owl-slider').owlCarousel({
        loop: true,
        margin: 0,
        nav: true,
        items: 1,
        autoplay: true,
        autoplayTimeout: 5000,
        animateIn: "fadeIn",
        navText:['<span><i class="icon icon-arrow-left"></i></span>','<span><i class="icon icon-arrow-right"></i></span>']
    });


    $('.lazy').show().lazy();

    //$('#googleMap').css('height',$('.contactbox').)

    $(document).scroll(function() {
        $('.article .bghover').css('height',$('.article .img img').outerHeight()).css('line-height',$('.article .img img').outerHeight()+'px');
    });
    /* START menu for tablets and mobiles */
    $("#head a.mobile-btn").click(function() {
        if($('#head ul').hasClass('active')){
            $('#head ul').removeClass('active');
            $(this).removeClass('active');
            $(this).find('i.icon').addClass('icon-menu').removeClass('icon-close');
        }else{
            $('#head ul').addClass('active');
            $(this).addClass('active');
            $(this).find('i.icon').removeClass('icon-menu').addClass('icon-close');
        }
    });

    var map = L.map('googleMap',{scrollWheelZoom: false}).setView([50.0925789, 14.4170806], 18);
    accessToken = 'pk.eyJ1Ijoicm9jZXNtYW5pYyIsImEiOiJja3lxMWg3N20wZmJyMm9wNndiMGtzaDhoIn0.SK_-NyJDCwao9Kpm8edA_Q';
    L.tileLayer('https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token='+accessToken, {
        attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
        maxZoom: 22,

        accessToken: 'pk.eyJ1Ijoicm9jZXNtYW5pYyIsImEiOiJjam5hb2NzazQyZWxoM2tydWd0OHN5OThkIn0.2kz8ZH1-HH-TkOh1anDHDA'
    }).addTo(map);

	var LeafIcon = L.Icon.extend({
		options: {
            iconSize:     [40, 61],
            iconAnchor:   [20, 0]
		}
	});
	var icons  = new LeafIcon({iconUrl: 'https://www.grandbohemia.cz/img/mapPin.png'});

	L.marker([50.0925789, 14.4181806], {icon: icons}).addTo(map);

});

function loadScript(url, completeCallback) {
   var script = document.createElement('script'), done = false,
       head = document.getElementsByTagName("head")[0];
   script.src = url;
   script.onload = script.onreadystatechange = function(){
     if ( !done && (!this.readyState ||
          this.readyState == "loaded" || this.readyState == "complete") ) {
       done = true;
       completeCallback();

      // IE memory leak
      script.onload = script.onreadystatechange = null;
      head.removeChild( script );
    }
  };
  head.appendChild(script);
}
